<template>
  <div class="DepartmentsViewHint">
    <div class="content">
      <div class="content__header">
        Wirtualne działy odzwierciedlają strukturę firmy
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Do każdego Wirtualnego Działu możesz dopisać konsultanta lub grupę konsultantów
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Wirtualne Działy możesz dowolnie przypisać do wybranego widgetu
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DepartmentsViewHint',


};
</script>
